const AnswerType = Object.freeze({
  Yes: 1,
  No: 2,
  L0: 3,
  L1: 4,
  L2: 5,
  L3: 6,
  L4: 7,
  L5: 8,
  Beginner: 9,
  Apprentice: 10,
  Proficient: 11,
  Advanced: 12,
});

export const levelAnswerTypes = [
  { id: AnswerType.L0, name: 'L0' },
  { id: AnswerType.L1, name: 'L1' },
  { id: AnswerType.L2, name: 'L2' },
  { id: AnswerType.L3, name: 'L3' },
  { id: AnswerType.L4, name: 'L4' },
  { id: AnswerType.L5, name: 'L5' },
];

export default AnswerType;